import { __assign, __read, __spread } from "tslib";
import { extractGroupBySettings } from '@keen.io/query';
import { KEEN_TABLE_INTERVAL } from '@keen.io/parser';
export var setChartSettings = function (_a) {
    var query = _a.query;
    var propertyNames = query.property_names, groupBy = query.group_by, interval = query.interval;
    var settings = {};
    if (propertyNames) {
        settings = __assign(__assign({}, settings), { columnsOrder: propertyNames });
    }
    if (groupBy) {
        settings = __assign(__assign({}, settings), { columnsOrder: interval
                ? __spread([KEEN_TABLE_INTERVAL], extractGroupBySettings(groupBy)) : extractGroupBySettings(groupBy) });
    }
    return __assign({}, settings);
};
